export default __webpack_public_path__ + "static/media/request-completed.232ff465.svg";